import React from 'react';
import { Box } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import Topbar from '@/modules/core/components/Topbar/Topbar';
import { useBreadcrumbs } from '@/modules/core/hooks/useBreadcrumbs';
import Renewals from '@/modules/employer/components/Renewals/Renewals';
import theme from '@/styles/theme';

const RenewalsPage = () => {
  useBreadcrumbs([{
    route: ROUTES.RENEWALS,
    title: 'Renewals',
  }]);
  return (
    <Box pad={{ top: '0', bottom: '40px' }} width="100%">
      <Topbar />
      <Box align="center" margin={{ top: 'medium' }}>
        <Box width={theme.defaultContentWidth}>
          <Renewals />
        </Box>
      </Box>
    </Box>
  );
};
export default RenewalsPage;
